import React from "react";
import { useEffect } from "react";
import { useLocation, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import ProjectList from "./components/ProjectList";
import ProjectDetails from "./components/Project/ProjectDetails";
import Profile from "./components/Profile";
import AdminHome from "./components/AdminHome";
import AddMember from "./components/AddMember";
import Plans from "./components/Plans";
import BookAsset from "./components/BookAsset";
import ProtectedRoute from "./components/ProtectedRoute"; // Import ProtectedRoute
import Login from "./components/Login";
import { AuthProvider } from "./contexts/AuthContext"; //Import AuthProvider
import AdminUserManagement from "./components/AdminUserManagement";
import BookingDetails from "./components/BookingDetails";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import EditTransaction from "./components/EditTransaction";
import UserProfile from "./components/UserProfile"; // Import UserProfile
import EditProfile from "./components/EditProfile"; // Import EditProfile
import "../src/styles/AppStyles.css"; // Import global styles
import ManageAssetTransaction from "./components/ManageAssetTransaction";
import UpdateAssetPurchase from "./components/UpdateAssetPurchase";
import Inventory from "./components/Inventory"; // Import Inventory
import "@fortawesome/fontawesome-free/css/all.min.css";
import Location from "./components/Location"; // Import Location component
import MigrateUsers from "./components/MigrateUsers";
import ProjectAdminForm from "./components/NewProject";
import MemberRankings from "./components/MemberRanking";
import OtherBenefitsList from "./components/OtherBenefitsList";
import AddBenefit from "./components/AddBenefit";
import EditBenefit from "./components/EditBenefit";

// Custom hook for focus management
function useFocusOnNavigate() {
  const location = useLocation();

  useEffect(() => {
    const mainContent = document.getElementById("main-content");
    if (mainContent) {
      // Small delay to ensure DOM is updated
      setTimeout(() => {
        mainContent.focus();
      }, 100);
    }
  }, [location.pathname]);
}
function App() {
  useFocusOnNavigate();

  return (
    <AuthProvider>
      {/* Wrap your application with AuthProvider */}

      <div className="app">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/projects" element={<ProjectList />} />
            <Route path="/login" element={<Login />} />
            <Route path="/projects/:id" element={<ProjectDetails />} />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute isAdminRoute={true}>
                  <AdminHome />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/add-member"
              element={
                <ProtectedRoute isAdminRoute={true}>
                  <AddMember />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/members"
              element={
                <ProtectedRoute isAdminRoute={true}>
                  <AdminUserManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/manage-asset-transactions"
              element={
                <ProtectedRoute isAdminRoute={true}>
                  <ManageAssetTransaction />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/user/:userId"
              element={
                <ProtectedRoute isAdminRoute={true}>
                  <UserProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/edit-profile/:userId"
              element={
                <ProtectedRoute isAdminRoute={true}>
                  <EditProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/booking-details/:transactionId"
              element={
                <ProtectedRoute>
                  <BookingDetails />
                </ProtectedRoute>
              }
            />
            <Route path="/plans" element={<Plans />} />
            <Route
              path="/book-asset/:projectId/:assetType"
              element={
                <ProtectedRoute>
                  <BookAsset />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-transaction/:id"
              element={
                <ProtectedRoute isAdminRoute={true}>
                  <EditTransaction />
                </ProtectedRoute>
              }
            />
            <Route
              path="/update-asset-purchase"
              element={
                <ProtectedRoute isAdminRoute={true}>
                  <UpdateAssetPurchase />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/inventory"
              element={
                <ProtectedRoute isAdminRoute={true}>
                  <Inventory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/location"
              element={
                <ProtectedRoute isAdminRoute={true}>
                  <Location />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/migrate"
              element={
                <ProtectedRoute isAdminRoute={true}>
                  <MigrateUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/add-project"
              element={
                <ProtectedRoute isAdminRoute={true}>
                  <ProjectAdminForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/member-rankings"
              element={
                <ProtectedRoute isAdminRoute={true}>
                  <MemberRankings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/other-benefits"
              element={<OtherBenefitsList />}
            />
            <Route path="/admin/other-benefits/new" element={<AddBenefit />} />
            <Route
              path="/admin/other-benefits/edit/:id"
              element={<EditBenefit />}
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </AuthProvider>
  );
}

export default App;
